import call from "../../../dashboard/service/http";
import constants from "./refereeConstants";
export default {
  state: {
    referees: [],
    referee: {},
  },
  mutations: {
    SET_REFEREE: (state, payload) => {
      state.referees = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    refereeGetters: (state) => (value) => state[value],
  },
  actions: {
    getreferee: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.referee(data))
        .then((res) => {
          commit("MUTATE", { state: "referee", data: res.data.data[0] });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    editreferee: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", constants.editreferee, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to referee
          Event.$emit("back");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    submitreferee: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.postreferee, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to referee
          Event.$emit("back");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deletereferee: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", constants.deletereferee(data), data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
